import React from "react";

import { isMeetinOpenUtil } from "../utils/meeting-utils";
import { USER_ROLES } from "./UserProvider";
import SideTabs from "./SideTabs";
import CompanyHeader from "./CompanyHeader";
import WherebyMeetingEmbed from "./WherebyMeetingEmbed";

const ReceptionOpen = ({
  sidebarCollapsed,
  meetingLink,
  meetingId,
  meetingDetails,
  ismeetingOpened,
  attendees,
  companyProfile,
  companyId,
  userIsInviteeToMeeting,
  role,
  onJoinMeeting = () => {},
  onLeaveMeeting = () => {},
}) => {
  return (
    <div className="row h-100">
      <div className="col-sm-12 col-md-8 col-xl-9">
        <div className="header text-center text-uppercase my-3">
          <CompanyHeader profile={companyProfile} />
        </div>

        <WherebyMeetingEmbed
          meetingLink={meetingLink}
          companyProfile={companyProfile}
          companyId={companyId}
          role={role}
          onClickLeaveMeeting={onLeaveMeeting}
        />

        {userIsInviteeToMeeting && role === USER_ROLES.DELEGATE && meetingId && (
          <div className="text-center mb-3">
            {meetingDetails && (
              <span>
                <button
                  className={`btn join-meeting-button ${
                    isMeetinOpenUtil(meetingDetails, ismeetingOpened)
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  type="button"
                  onClick={onJoinMeeting}
                  disabled={!isMeetinOpenUtil(meetingDetails, ismeetingOpened)}
                >
                  JOIN MEETING
                </button>
              </span>
            )}
          </div>
        )}
      </div>

      {/* Sidebar */}
      <div className="col-sm-12 col-md-4 col-xl-3 px-0">
        <SideTabs
          sidebarCollapsed={sidebarCollapsed}
          attendees={attendees}
          attendeesTabLabel="Attendees"
          chatTabLabel="Chat"
          showAttendeesTab={true}
          ShowChatTab={true}
        />
      </div>
    </div>
  );
};

export default ReceptionOpen;
